import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import { useNavigate } from 'react-router-dom';
import { HOME_PATH, LOGIN_PATH } from '@/constants/paths';
import useLogout from '@hooks/useLogout';

export const RegistrationPendingKit = () => {
  const navigate = useNavigate();
  const logout = useLogout();
  const primaryActionOnClick = () => navigate(HOME_PATH);
  const handleLogout = () => {
    logout();
    navigate(LOGIN_PATH);
  }

  return (
    <RegistrationScreen
      title="Oops! Only one kit at a time"
      description="Before registering a new kit, you will have to review results and
        recommendations for your most recent active kit."
      content={<div data-testid="registrationPendingKit-content" />}
      primaryActionLabel="Review results"
      primaryActionOnClick={primaryActionOnClick}
      secondaryActionLabel="Login as a different user"
      secondaryActionOnClick={handleLogout}
      data-testid="registrationPendingKit-screen"
    />
  );
};
